export const getChartChipShortName = (name) => {
  if (name === 'wildcard') return 'WC';
  if (name === 'bboost') return 'BB';
  if (name === 'freehit') return 'FH';
  if (name === '3xc') return 'TC';
};

export const getChartChipLongName = (name) => {
  if (name === 'wildcard') return 'Wildcard';
  if (name === 'bboost') return 'Bench Boost';
  if (name === 'freehit') return 'Free hit';
  if (name === '3xc') return 'Triple Captain';
};

export const formatChartYAxisNumber = (value) => {
  if (value >= 1000000) {
    // Divide by 1 million and round to one decimal place
    return (value / 1000000).toFixed(1) + 'm';
  } else if (value >= 1000) {
    // Divide by 1000
    return value / 1000 + 'k';
  } else {
    return value;
  }
};

export const getBestAndWorstPosition = (gameweeks) => {
  if (!gameweeks) return { best: null, worst: null };
  const sortedByOverallRank = gameweeks.sort(
    (a, b) => a.overall_rank - b.overall_rank
  );
  const best = sortedByOverallRank[0];
  const worst = sortedByOverallRank[gameweeks.length - 1];
  return { best, worst };
};
